import React from 'react';
import { useB2BTranslation } from '../hooks/useB2BTranslation';
import { Save } from 'lucide-react';
import './B2BSaveProfileButton.css';

interface B2BSaveProfileButtonProps {
  onClick?: () => void;
  disabled?: boolean;
  isLoading?: boolean;
  className?: string;
  size?: 'small' | 'medium' | 'large';
  variant?: 'primary' | 'secondary' | 'outline';
  showIcon?: boolean;
  children?: React.ReactNode;
  type?: 'button' | 'submit' | 'reset';
}

const B2BSaveProfileButton: React.FC<B2BSaveProfileButtonProps> = ({
  onClick,
  disabled = false,
  isLoading = false,
  className = '',
  size = 'medium',
  variant = 'primary',
  showIcon = true,
  children,
  type = 'submit'
}) => {
  const { t } = useB2BTranslation();
  
  const buttonClasses = `b2b-save-profile-button b2b-save-profile-button--${size} b2b-save-profile-button--${variant} ${className}`;

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || isLoading}
      className={buttonClasses}
    >
      {isLoading ? (
        <>
          <div className="b2b-save-profile-button__spinner" aria-hidden="true" />
          {t('dashboard.profile.saving')}
        </>
      ) : (
        <>
          {showIcon && <Save size={16} aria-hidden="true" />}
          {children || t('buttons.saveProfile')}
        </>
      )}
    </button>
  );
};

export default B2BSaveProfileButton;


